<template>
  <div id="v-content">
    <!-- f10相关页面 -->
    <div class="f10Page">
      <router-view class="router-view">

      </router-view>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'HomeF10',
  data() {
    return {
      Height: 0
    }
  },
  computed: {
    ...mapGetters(['isIndexGetter'])
  },
  watch: {
    '$route'(to, from) {
      window.scrollTo(0, 0)
    }
  },
  mounted() {
    // 动态设置内容高度 让footer始终居底   header+footer的高度是100
    this.Height = document.documentElement.clientHeight - 350
    // 监听浏览器窗口变化
    window.onresize = () => { this.Height = document.documentElement.clientHeight - 350 }
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>
.f10Page{
  min-height: 100vh;
  background-color: #ffffff;
}
</style>
